<script>
    import {link} from 'svelte-spa-router'
    export let href,src,text
</script>

<a href={href} use:link>
    <div>
        <picture>   
            <source srcset={src.pc} media="(min-width: 641px)" />
            <source srcset={src.mb} media="(min-width: 0px)" >
            <img src={src.pc} alt="">
        </picture>

        <p>{text}</p>
    </div>
</a>
<style>
    a{    
        width: 523px;
        height: 380px;
        border-radius: 10px;
        position: relative;
        display: flex;
        transition:all .5s;
        position: relative;
    }
    a:after{
        content:"→";
        position: absolute;
        bottom:20px;
        right:17px;
        
        font-size: 20px;
        line-height: 36px;
        font-family: "Noto Sans JP",sans-serif;
        color: #000;
    }
    div{
        display: flex;
        flex-direction: column;
        position: relative;
    }
    img{
        width: 523px;
        height: 380px;  
    }
    p{
        margin: 0; 
        position: absolute;
        bottom: 0;
        display: flex;
        width: 523px;
        height: 78px;
        border-radius: 0px 0px 10px 10px;
        background: #fff;
        font-family: "Noto Sans JP",sans-serif;
        justify-content: center;
        align-items: center;
        
        font-size: 20px;
        line-height: 36px;
        text-align: left;
        color: #000;
    }
    a:hover{
        opacity:.5;
        transition:all .5s;
    }
    @media screen and (max-width:640px){
        a{    
            width: 324px;
            height: 335px;
            margin-top: 70px;
        }
        p{
            width: 324px;
            height: 78px;
        }
        img{
            width: 324px;
            height: auto;
        }
    }
</style>